import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Production aur Localhost ke liye sahi BASE_URL configuration
const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8002'
    : 'https://likaiev.com';

const Products = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/api/products/`);
                setProducts(Array.isArray(response.data) ? response.data : response.data.results || []);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching products:", error);
                setProducts([]);
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    // Product Images ke URL ko secure aur handle karne ke liye helper function
    const getImageUrl = (item) => {
        if (item.images && item.images.length > 0) {
            let imgPath = item.images[0].image;
            if (imgPath) {
                if (imgPath.includes('66.116.250.115:8002') || imgPath.includes('127.0.0.1')) {
                    return imgPath.replace(/http:\/\/[^/]+/, BASE_URL);
                }
                if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) {
                    return imgPath;
                }
                return `${BASE_URL}${imgPath}`;
            }
        }
        return '/placeholder.jpg';
    };

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Banner Section with Safe Inline Style */}
            <div
                className="relative h-[350px] w-full flex items-center justify-center mb-16 overflow-hidden bg-cover bg-center"
                style={{
                    backgroundImage: "url('/banner1.jpg')"
                }}
            >
                {/* Dark Overlay for text readability */}
                <div className="absolute inset-0 bg-blue-900/70"></div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="relative z-10 text-center px-4"
                >
                    <h1 className="text-5xl md:text-6xl font-extrabold text-white tracking-wider mb-4">OUR PRODUCTS</h1>
                    <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
                    <p className="text-blue-100 mt-4 text-lg">High quality industrial solutions with trust and excellence.</p>
                </motion.div>
            </div>

            <div className="container mx-auto px-4 pb-20">
                {loading ? (
                    <div className="text-center text-xl font-bold py-20">Loading Products...</div>
                ) : !Array.isArray(products) || products.length === 0 ? (
                    <div className="text-center text-xl text-gray-500 py-20">No products found.</div>
                ) : (
                    /* Ek row mein 5 columns ke liye grid-cols-5 set kiya hai */
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
                        {products.map((item, index) => (
                            <motion.div
                                key={item.id}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                                className="bg-white p-4 rounded-2xl shadow-lg hover:shadow-2xl transition border border-gray-100 flex flex-col justify-between"
                            >
                                <div>
                                    <div className="mb-4 overflow-hidden rounded-lg">
                                        <img
                                            src={getImageUrl(item)}
                                            alt={item.title}
                                            className="w-full h-44 object-cover hover:scale-105 transition duration-500"
                                        />
                                    </div>

                                    <div className="bg-blue-100 text-blue-900 font-bold px-2 py-0.5 rounded-full text-[10px] inline-block mb-3">
                                        {item.category || "General"}
                                    </div>
                                    <h3 className="text-lg font-bold text-gray-900 mb-2 truncate">{item.title}</h3>
                                    <p className="text-gray-600 text-xs leading-relaxed mb-4 line-clamp-3">{item.description}</p>
                                </div>

                                <Link to={`/products/${item.id}`} className="mt-auto">
                                    <button className="w-full py-2 border-2 border-blue-900 text-blue-900 text-xs font-bold rounded-lg hover:bg-blue-900 hover:text-white transition">
                                        LEARN MORE →
                                    </button>
                                </Link>
                            </motion.div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Products;